// Statisk menustruktur og kontaktoplysninger baseret på det skrabede websted
export const CONTACT_INFO = {
  name: "Vester-Bo",
  address: "Vestergade 10-12, 6670 Holsted",
  phone: "+45 5120 6129",
  email: "vester-bo@mail.tele.dk",
  mariannePhone: "23609905",
  privacyPolicyUrl: "https://www.iubenda.com/privacy-policy/10398261",
  cookiePolicyUrl: "https://www.iubenda.com/privacy-policy/10398261/cookie-policy",
  tilsynsrapportUrl: "https://assets.auxodev.dk/assets/c39928d5-b2a6-4904-83a9-11ba7b5b852e/tilsynsrapport-2024-vester-bo.pdf"
};

export const MENU_STRUCTURE = [
  {
    label: "Informationer",
    href: "#",
    isMega: true,
    children: [
      {
        label: "Om Vester-Bo",
        href: "/om-vester-bo",
        slug: "om-vester-bo",
        children: [
          { label: "Målgruppe", href: "/m-c3-a5lgruppe", slug: "m-c3-a5lgruppe" },
          { label: "Formål", href: "/form-c3-a5l", slug: "form-c3-a5l" },
          { label: "Værdigrundlag", href: "/v-c3-a6rdigrundlag", slug: "v-c3-a6rdigrundlag" },
          { label: "Beboerbetaling", href: "/beboerbetaling", slug: "beboerbetaling" },
          { label: "Profil", href: "/profil", slug: "profil" },
          { label: "Tilsyn", href: "/tilsyn", slug: "tilsyn" }
        ]
      },
      {
        label: "Vester-Bo tilbyder",
        href: "/hvad-tilbyder-vester-bo",
        slug: "hvad-tilbyder-vester-bo",
        children: [
          { label: "Miljøterapi og samtaler", href: "/milj-c3-b8terapi-og-samtaler", slug: "milj-c3-b8terapi-og-samtaler" },
          { label: "Medindflydelse i Dagligdagen", href: "/medindflydelse-medbestemmelse-ansvarlighed-i-dagligdagen", slug: "medindflydelse-medbestemmelse-ansvarlighed-i-dagligdagen" },
          { label: "Medbestemmelse for opholdet", href: "/medbestemmelse-mht-m-c3-a5l-opholdet", slug: "medbestemmelse-mht-m-c3-a5l-opholdet" },
          { label: "NADA", href: "/nada", slug: "nada" },
          { label: "Udadrettede aktiviteter", href: "/udadrettede-aktiviteter", slug: "udadrettede-aktiviteter" },
          { label: "Transport", href: "/transport", slug: "transport" },
          { label: "Daglige gøremål / fritid", href: "/daglige-g-c3-b8rem-c3-a5l-fritid", slug: "daglige-g-c3-b8rem-c3-a5l-fritid" },
          { label: "Beskæftigelse udenfor huset", href: "/besk-c3-a6ftigelse-udenfor-huset", slug: "besk-c3-a6ftigelse-udenfor-huset" },
          { label: "Faste holdepunkter i dagen", href: "/faste-holdepunkter-i-l-c3-b8bet-af-dagen", slug: "faste-holdepunkter-i-l-c3-b8bet-af-dagen" },
          { label: "Alkohol og euforiserende stoffer", href: "/klare-regler-om-alkohol-og-euforiserende-stoffer", slug: "klare-regler-om-alkohol-og-euforiserende-stoffer" },
          { label: "Undervisning", href: "/undervisning", slug: "undervisning" },
          { label: "Hjælp til medicinadministration", href: "/hj-c3-a6lp-til-medicinadministration", slug: "hj-c3-a6lp-til-medicinadministration" },
          { label: "Hjælp til økonomi", href: "/hj-c3-a6lp-til-c3-b8konomi", slug: "hj-c3-a6lp-til-c3-b8konomi" },
          { label: "Sund livsstil", href: "/sund-livsstil", slug: "sund-livsstil" },
          { label: "Privatliv", href: "/privatliv", slug: "privatliv" },
          { label: "Opretholdelse / etablering af netværk", href: "/opretholdelse-etablering-af-netv-c3-a6rk", slug: "opretholdelse-etablering-af-netv-c3-a6rk" },
          { label: "Udflytning", href: "/udflytning", slug: "udflytning" },
          { label: "I Holsted forefindes bl.a.", href: "/i-holsted-forefindes-bla", slug: "i-holsted-forefindes-bla" }
        ]
      }
    ]
  },
  {
    label: "Fysiske rammer",
    href: "/fysiske-rammer",
    slug: "fysiske-rammer",
    children: [
      { label: "Hovedbygningen", href: "/hovedbygningen", slug: "hovedbygningen" },
      { label: "Annekset", href: "/annekset", slug: "annekset" },
      { label: "Øvrige bygninger", href: "/c3-b8vrige-bygninger", slug: "c3-b8vrige-bygninger" },
      { label: "Grundtegning over området", href: "/grundtegning-over-omr-c3-a5det", slug: "grundtegning-over-omr-c3-a5det" },
      { label: "Brandsikkerhed", href: "/brandsikkerhed", slug: "brandsikkerhed" }
    ]
  },
  {
    label: "Tilsyn i eget hjem",
    href: "/tilsyn",
    slug: "tilsyn",
    children: []
  },
  {
    label: "Ledige pladser",
    href: "/ledige-pladser",
    slug: "ledige-pladser",
    children: []
  },
  {
    label: "Medarbejdere",
    href: "/medarbejdere",
    slug: "medarbejdere",
    children: [
      { label: "Personale / Normering", href: "/personale-normering", slug: "personale-normering" },
      { label: "Personale", href: "/personale", slug: "personale" }
    ]
  }
];
